import React from 'react';
import { components, ControlProps } from 'react-select';
import { CountriesOption, DestinationOption } from '@lt/api/dist/methods/references/types';
import { Search } from '@lt/components/icons-react/userflow';
import styled from 'styled-components';
import { destinationPickerName } from '../../constants';

export const Control = ({ children, ...props }: ControlProps<DestinationOption, false>) => {
  const { getValue, hasValue, selectProps } = props;
  const [value] = getValue() as CountriesOption[] | { destination: CountriesOption }[];
  const visa = value && 'destination' in value ? value.destination?.visa : value?.visa;

  return (
    <components.Control {...props}>
      <SearchIcon
        className={`${destinationPickerName}__icon-search`}
        $highlighted={hasValue || !!selectProps.inputValue}
      />
      {children}
      <span className={`${destinationPickerName}__control-visa`}>{visa}</span>
    </components.Control>
  );
};

const SearchIcon = styled(Search)<{ $highlighted: boolean }>`
  width: 24px;
  height: 24px;
  stroke: ${({ $highlighted }) => ($highlighted ? '#17181a' : '#919499')};
`;
